import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  artist: belongsTo('artist', { inverse: null }),
  categories: hasMany('category', { inverse: null }),
  channel: belongsTo('channel', { inverse: null }),
  taxa: hasMany('taxon', { inverse: null }),
});
